import { API } from '@shared/types/api';
import { useChannel } from '@shared/util/hooks';
import { MBChatBannerComponent } from '../components/banner';

interface Props {
  channelSlug: string;
  creator: API.ShortUserFragment;
}

export function MBChatBanner({ channelSlug, creator }: Props) {
  const channel = useChannel({ channelSlug });

  if (!channel) {
    return null;
  }

  return <MBChatBannerComponent channel={channel} creator={creator} />;
}
